import React from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

import styles from "./PackagesSection.module.scss";

const PackagesSection = () => (
  <div className={styles.container}>
    <div className={styles.welcomeCard}>
      <div className={styles.iconWrapper}>
        <Inventory2OutlinedIcon className={styles.icon} />
      </div>
      <h1 className={styles.title}>Welcome to the Packages Section</h1>
      <p className={styles.message}>
        Package management is not available in this dashboard yet.
      </p>
    </div>
  </div>
);

export default PackagesSection;
